import { useState, useCallback } from 'react';

export const useProgressNotification = () => {
  const [notification, setNotification] = useState({
    isVisible: false,
    title: '',
    progress: 0,
    total: 0,
    isComplete: false,
    isError: false,
    errorMessage: ''
  });

  const showProgress = useCallback((title, total = 0) => {
    setNotification({
      isVisible: true,
      title,
      progress: 0,
      total,
      isComplete: false,
      isError: false,
      errorMessage: ''
    });
  }, []);

  const updateProgress = useCallback((progress) => {
    setNotification(prev => ({
      ...prev,
      progress: Math.min(progress, prev.total)
    }));
  }, []);

  const completeProgress = useCallback(() => {
    setNotification(prev => ({
      ...prev,
      isComplete: true,
      progress: prev.total
    }));
  }, []);

  const errorProgress = useCallback((errorMessage) => {
    setNotification(prev => ({
      ...prev,
      isError: true,
      errorMessage
    }));
  }, []);

  const hideProgress = useCallback(() => {
    setNotification(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);

  const resetProgress = useCallback(() => {
    setNotification({
      isVisible: false,
      title: '',
      progress: 0,
      total: 0,
      isComplete: false,
      isError: false,
      errorMessage: ''
    });
  }, []);

  return {
    notification,
    showProgress,
    updateProgress,
    completeProgress,
    errorProgress,
    hideProgress,
    resetProgress
  };
};
